export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10185.0d33b8b8.jpg";